import axios from 'axios';

/**
 * Create an Axios Client with defaults
 */
const client = axios.create({
  baseURL: ( process.env.REACT_APP_API_POLL_URL_BASE + process.env.REACT_APP_API_POLL_RESOURCE)
});

/**
 * Request Wrapper with default success/error actions
 */
const request = options => {
  client.defaults.headers.common.Authorization = 'Bearer '.concat(
    window.sessionStorage.getItem('token')
  );

  const onSuccess = response => {
    return response;
  };

  const onError = error => {
    return Promise.reject(error.response || error.message);
  };

  return client(options)
    .then(onSuccess)
    .catch(onError);
};

export default request;
